import _ from 'lodash'
import {
  colorVars,
  ColorNames,
  BlendedColorNames,
  blendedColorVars,
} from '../constants/colorVars'
import { lightenColor } from './lightenColor'

const colorLongToShort = (colorName: string): string =>
  _.camelCase(colorName.substring(8))

const colorShortToLong = (colorName: string): string =>
  _.camelCase(`utkColor${_.startCase(colorName)}`)

const getCssColorFromColorName = (
  colorName: ColorNames | BlendedColorNames
): string => {
  const key = colorShortToLong(colorName)

  // Use type assertion with 'as any' to avoid the keyof typeof issue
  if (key in colorVars) {
    return (colorVars as any)[key]
  }

  if (key in blendedColorVars) {
    return (blendedColorVars as any)[key]
  }

  // fail silently
  return ''
}

const INHERIT = 'inherit'

const colorOptions = _.keys(colorVars).map(colorLongToShort)
const blendedColorOptions = _.keys(blendedColorVars).map(colorLongToShort)

// keeping this colorVars export for backwards compatibility
export {
  ColorNames,
  colorVars,
  colorLongToShort,
  colorShortToLong,
  getCssColorFromColorName,
  INHERIT,
  lightenColor,
  colorOptions,
  blendedColorOptions,
}
